// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-preview[data-v-3ecd1ae6] {\n  width: 200px;\n  height: 200px;\n}\n.media-preview__content[data-v-3ecd1ae6] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
